export const dates = (theme) => ({
    background: theme.colors?.surface.default,
    border: theme.colors?.border.control,
    boxShadow: theme.colors?.effects.shadowColor,
    tabs: {
        color: theme.colors?.text.link.default,
        activeColor: theme.colors?.text.basic.primary,
        activeBorder: theme.colors?.component?.brand?.default,
    },
    quick: {
        titleColor: theme.colors?.text.basic.primary,
        linkColor: theme.colors?.text.basic.primary,
        linkHoverColor: theme.colors?.text.basic.primary,
        linkHoverBackground: theme.colors?.component.hover,
        linkSelectedColor: theme.colors?.text.basic.primary,
        linkSelectedBackground: theme.colors?.surface.defaultAlt,
    },
    absolute: {
        input: {
            backgroundColor: theme.colors?.surface.subtle,
            color: theme.colors?.text.basic.primary,
            borderColor: theme.colors?.border.control,
            activeBorderColor: theme.colors?.border.focus,
        },
        today: {
            color: theme.colors?.text.basic.primary,
            backgroundColor: theme.colors?.surface.subtle,
            borderColor: theme.colors?.border.alt,
        },
    },
    time: {
        color: theme.colors?.text.basic.primary,
        background: theme.colors?.surface.default,
        selectedItemColor: theme.colors?.text.basic.primary,
        selectedItemBackground: theme.colors?.component?.brandLight?.default,
    },
    dayName: {
        color: theme.colors?.text.basic.secondary,
    },
    day: {
        color: theme.colors?.text.basic.primary,
        colorInRange: theme.colors?.text.basic.primary,
        colorOutsideMonth: theme.colors?.foreground.subtle,
        colorStartEndRange: theme.colors?.text.basic.inverse,
        selectedBackground: theme.colors?.component?.brandLight?.default,
        inSelectingRangeBackground: theme.colors?.component?.brandLight?.default,
        inRangeBackground: theme.colors?.component?.brandLight?.default,
        rangeStartEndBackground: theme.colors?.component?.brand?.default,
        todayBackground: theme.colors?.surface.subtle,
        highlightColor: theme.colors?.text.brand,
    },
    navigation: {
        currentMonthColor: theme.colors?.text.basic.primary,
        iconColor: theme.colors?.text.basic.primary,
        borderColor: theme.colors?.border.alt,
    },
    variants: {
        explore: {
            time: {
                selectedItemColor: theme.colors?.text.basic.inverse,
                selectedItemBackground: theme.colors?.component?.brand?.default,
            },
            day: {
                selectedBackground: theme.colors?.component?.brandLight?.default,
                inSelectingRangeBackground: theme.colors?.component?.brandLight?.default,
                inRangeBackground: theme.colors?.component?.brandLight?.default,
                rangeStartEndBackground: theme.colors?.component?.brand?.default,
                highlightColor: theme.colors?.text.brand,
            },
            quick: {
                linkSelectedBackground: theme.colors?.surface.subtle,
                linkSelectedColor: theme.colors?.text.basic.primary,
                linkColor: theme.colors?.text.link.default,
                linkHoverColor: theme.colors?.text.link.default,
            },
        },
    },
});
//# sourceMappingURL=dates.js.map